// extracted by mini-css-extract-plugin
export default {"card":"InnerCard_card__+JqOQ","container":"InnerCard_container__lYJY1","ImageSize":"InnerCard_ImageSize__qICyj"};